const FrontDeskStats = ({ stats }) => {
  const items = [
    { label: 'Upcoming', value: stats.upcoming },
    { label: 'On floor', value: stats.arrived },
    { label: 'Completed', value: stats.completed },
    { label: 'Taken today', value: stats.revenueLabel, emphasize: true },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {items.map((item) => (
        <div key={item.label} className="bg-sand-50 px-4 py-4 ring-1 ring-ink-900/10 sm:px-5">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-600/60">
            {item.label}
          </p>
          <p
            className={`mt-2 font-display text-2xl font-light tracking-tight text-ink-900 sm:text-3xl ${
              item.emphasize ? '' : 'tabular-nums'
            }`}
          >
            {item.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default FrontDeskStats;
